import { Typography } from '@packages/ui/shared';
import { TableHeader, TableRow, SORT_DIRECTION } from '@web/components/table';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';

const useDmsListStyles = createUseStyles({
    jobCell: {
        minWidth: '165px',
    },
    totalJobs: {
        minWidth: '100px',
    },
    roMileage: {
        minWidth: '110px',
    },
    tableCell: {
        minWidth: '140px',
    },
});
interface DmsTableHeaderProps {
    onSort: (key: string, direction: SORT_DIRECTION) => void;
    sortBy: string | null;
    sortDirection: SORT_DIRECTION;
}

export const DmsTableHeader = ({ onSort, sortBy, sortDirection }: DmsTableHeaderProps) => {
    const { t } = useTranslation();
    const classes = useDmsListStyles();

    const TABLE_HEADER_TITLES = [
        { key: 'roNumber', title: 'Repair Order #', width: '11%', className: classes.tableCell, sortable: false },
        { key: 'closedDate', title: 'Closed Date', width: '12%', className: classes.tableCell, sortable: true },
        { key: 'mileage', title: 'RO Mileage', width: '10%', className: classes.roMileage, sortable: true },
        { key: 'totalJobs', title: 'Total Jobs', width: '10%', className: classes.totalJobs, sortable: false },
        { key: 'jobComplaint', title: 'Job Complaint', width: '15%', className: classes.jobCell, sortable: false },
        { key: 'jobCause', title: 'Job Cause', width: '14%', className: classes.jobCell, sortable: false },
        { key: 'jobCorrection', title: 'Job Correction', width: '14%', className: classes.jobCell, sortable: false },
        { key: 'jobSalesType', title: 'Job Sales Type', width: '14%', className: classes.jobCell, sortable: false },
    ];

    return (
        <TableRow>
            {TABLE_HEADER_TITLES.map((header) => (
                <TableHeader
                    key={header.key}
                    width={header.width}
                    className={header.className}
                    sortable={header.sortable}
                    sortDirection={sortBy === header.key ? (sortDirection as SORT_DIRECTION) : undefined}
                    onSort={(_event, direction) => onSort(header.key, direction)}
                >
                    <Typography variant="label">{t(header.title)}</Typography>
                </TableHeader>
            ))}
        </TableRow>
    );
};
